module.exports = __webpack_public_path__ + "img/locations.5769d70a.gif";